// import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { FaFacebookSquare } from "react-icons/fa";
import { FaBluesky, FaDiscord, FaTiktok } from "react-icons/fa6";
import { RiInstagramFill } from "react-icons/ri";

import LightTaglineLogo from "@/assets/images/logo-light-tagline-hor.svg";

export const SvFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-light text-dark mt-6">
      <div className="container flex w-full flex-col flex-wrap items-start justify-start gap-8 py-8 md:flex-row md:items-end lg:gap-16">
        <div className="w-full lg:w-auto">
          <LightTaglineLogo className="block" />
        </div>

        <div className="flex flex-col justify-start gap-2 md:justify-end">
          {/*<div className="col-span-2 text-sm font-bold text-[#525360]">
            <Trans i18nKey="footer.contact" />
          </div>
          <div className="flex flex-row gap-4">
            <Link to="/contact" className="hover:text-primary text-sm">
              <Trans i18nKey="footer.support" />
            </Link>*/}
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeCqSwpjlkU-u8fGw0pvYpjgN6sG4QBHeGi66CS7Pnq5MsxVA/viewform?usp=header"
            target="_blank"
            rel="noreferrer"
            className="hover:text-primary text-sm">
            {t("footer.volunteer")}
          </a>
          {/*</div>*/}
        </div>

        <div className="flex flex-col gap-4 md:ml-auto">
          <div className="flex flex-row justify-start md:justify-end">
            <div className="flex flex-row justify-start gap-4 text-xl">
              <a
                href="https://www.tiktok.com/@smartvotingca"
                target="_blank"
                rel="noreferrer"
                className="group relative z-0">
                <FaTiktok className="pointer-events-none absolute top-0 left-0 -z-10 text-[#fe2c55] transition-transform group-hover:translate-x-[2px] group-hover:translate-y-[1px]" />
                <FaTiktok className="pointer-events-none absolute top-0 left-0 -z-20 text-[#00f2ea] transition-transform group-hover:translate-x-[-2px] group-hover:translate-y-[-1px]" />
                <FaTiktok className="z-00 transition-colors group-hover:text-gray-900" />
              </a>
              <a
                href="https://bsky.app/profile/smartvoting.ca"
                target="_blank"
                rel="noreferrer"
                className="transition-colors hover:text-[#1185fe]">
                <FaBluesky />
              </a>
              <a
                href="https://www.instagram.com/smartvotingca/"
                target="_blank"
                rel="noreferrer"
                className="transition-colors hover:text-[#e1306c]">
                <RiInstagramFill />
              </a>
              <a
                href="https://discord.gg/6PUEGAsZVv"
                target="_blank"
                rel="noreferrer"
                className="transition-colors hover:text-[#5865f2]">
                <FaDiscord />
              </a>
              <a
                href="https://www.facebook.com/SmartVotingCA"
                target="_blank"
                rel="noreferrer"
                className="transition-colors hover:text-[#17a9fd]">
                <FaFacebookSquare />
              </a>
            </div>
          </div>
          <div className="text-xs font-medium">{t("footer.copyright")}</div>
        </div>
      </div>
    </footer>
  );
};
